import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../global.service';

@Component({
  selector: 'elastic-ad-service',
  templateUrl: './ad-service.component.html',
  styleUrls: ['./ad-service.component.scss']
})
export class AdServiceComponent implements OnInit {

  @Input() adpos;

  banners = false;
  data = {
    'banner_url' : '',
    'campaign_id': 0
  };
  data2 = [];
  activeIndex = 0;
  constructor(private http: HttpClient, private globalService: GlobalService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {

    this.getAd(this.adpos);

  }

  getAd(pos) {

    this.http.get(this.globalService.apiUrl + '/a?p=' + btoa(pos)).subscribe( (data: any) => {

      if (data) {
        data.forEach( (banner) => {
          banner.banner_url = atob(banner.banner_url);
          banner.campaign_id = btoa(banner.campaign_id);
        });
        this.banners = true;
        this.data2 = data;
        this.rotate(-1);
      }

    });

  }

  rotate(index) {

    if (this.data2[index+1]) {
      this.activeIndex = index+1;
      this.data.banner_url = this.data2[this.activeIndex].banner_url;
      this.data.campaign_id = this.data2[this.activeIndex].campaign_id;
    } else {
      this.activeIndex = 0;
      this.data.banner_url = this.data2[this.activeIndex].banner_url;
      this.data.campaign_id = this.data2[this.activeIndex].campaign_id;
    }

    this.cdr.detectChanges();

    if (this.data2.length > 1) {
      setTimeout( () => {
        this.rotate(this.activeIndex);
      }, 10000);
    }

  }

}
